import { createContext, PropsWithChildren, useContext } from 'react';

import useQuestionExamGrades, {
  QuestionExamGradeContextValue,
} from '@/data/hook/exam/useQuestionExamGrades';

const QuestionExamGradeContext = createContext<
  QuestionExamGradeContextValue | undefined
>(undefined);

type QuestionExamGradeProviderProps = PropsWithChildren<{
  examAreaId: number;
}>;

export function QuestionExamGradeProvider({
  examAreaId,
  children,
}: QuestionExamGradeProviderProps) {
  const value = useQuestionExamGrades({ examAreaId });
  return (
    <QuestionExamGradeContext.Provider value={value}>
      {children}
    </QuestionExamGradeContext.Provider>
  );
}

export const useQuestionExamGradeCtx = () =>
  useContext(QuestionExamGradeContext);
